import type { ReactNode } from "react";
import { useApi } from "@pcs/telemetry-api";
import useApiInterceptors from "@/api/useApiInterceptors";

interface ApiAuthWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that sets up axios interceptors for the API client.
 * Must be rendered inside an `ApiProvider`.
 *
 * Handles token injection, Customer-Id headers, and 401 responses.
 *
 * Body matches the mono.ui pattern verbatim. When `Pcs.Authorization.Web`
 * is merged into the mono.ui workspace, the only required change is to
 * switch the `useApiInterceptors` import from `@/api/useApiInterceptors`
 * to `@pcs/shared`.
 */
function ApiAuthWrapper({ children }: ApiAuthWrapperProps): ReactNode {
  const { api } = useApi();
  useApiInterceptors([api.http.instance]);
  return children;
}

export default ApiAuthWrapper;
